import React from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo.jsx';
import ContactCta from '../components/cta/ContactCta.jsx';
import Hero from './landing/Hero.jsx';
import WhatWeDo from './landing/WhatWeDo.jsx';
import ChatSection from './landing/ChatSection.jsx';

/**
 * Landing page composed of section components.
 * @returns {JSX.Element} Landing page
 */
function Landing() {
  const { t } = useTranslation();

  return (
    <>
      <Seo title={t('seo.title')} description={t('seo.description')} />
      <Hero />
      <WhatWeDo />
      <ChatSection />
      <ContactCta />
    </>
  );
}

export default Landing;
